import * as React from "react";
import { User, Category } from "../../api/classes";
import Table from "./table";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import Loading from "../../components/loading";

interface Props {
  categories: Category[];
  fetchCategories: () => void;
}
class Categories extends React.Component<Props> {
  componentWillMount() {
    if (!this.props.categories) {
      this.props.fetchCategories();
    }
  }
  render() {
    if (!this.props.categories) {
      return <Loading />;
    }
    return (
      <div
        style={{
          flex: 1,
          padding: 24,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowY: "scroll"
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 1000,
            marginLeft: 24,
            marginRight: 24
          }}
        >
          <Table elements={this.props.categories} />
        </div>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    categories: state.cases.categories
  }),
  dispatch => ({
    fetchCategories: (): any => dispatch(actions.fetchCategories())
  })
)(Categories);



// WEBPACK FOOTER //
// ./src/pages/categories/index.tsx